<template>
    <div class="result-hero-wrapper">
        <div class="container">
            <div class="col result-hero-container">
                <ResultHeroDetails
                    :declinedLenders="declinedLenders"
                    :numberOfOffers="numberOfOffers"
                    :numberOfExpiredOffers="numberOfExpiredOffers"
                    :applicationData="applicationData"
                    :isDebtSolutionOffer="isDebtSolutionOffer"
                    :offers="offers"
                    :hasNonAlternativeOffers="hasNonAlternativeOffers"
                />

                <div
                    class="result-hero-lenders"
                    v-if="
                        !declinedAndAlt.includes(status) &&
                        !isEmpty(declinedLenders) &&
                        showResultHeroLendersBlock &&
                        !isLendindtree &&
                        hasNonAlternativeOffers
                    "
                >
                    <div class="lender-details">
                        <div class="lenders-info">
                            {{ $t('results.heroBanner.declinedLenders', { numberOfLenders: declinedLenders.length }) }}
                            {{ $tc('results.heroBanner.lender', declinedLenders.length) }}<span class="colon">:</span>
                        </div>

                        <div class="lender-pins mt-2 mb-2">
                            <div class="lender-pin" v-for="(lender, lenderIndex) in firstLenders" :key="lenderIndex">
                                <img :src="lender.logo_url" alt="" />
                            </div>
                            <div v-if="remainingLenders.length" class="lender-pin extra-lender-counter">
                                <span>+{{ remainingLenders.length }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="lender-actions">
                        <button class="button bordered hollow" @click="goTo('declinedLendersBlock')">
                            <span class="text">{{
                                $tc('results.heroBanner.buttons.showMeTheseOffers', declinedLenders.length)
                            }}</span>
                            <i class="far fa-arrow-down"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

// lodash components
import take from 'lodash/take'
import takeRight from 'lodash/takeRight'
import isEmpty from 'lodash/isEmpty'
import capitalize from 'lodash/capitalize'
import some from 'lodash/some'
import split from 'lodash/split'
import toNumber from 'lodash/toNumber'

export default {
    setup() {
        const store = useStore()
        const route = useRoute()
        const router = useRouter()

        return {
            route,
            router,
            store,
        }
    },
    props: {
        declinedLenders: Array,
        numberOfOffers: Number,
        numberOfExpiredOffers: Number,
        applicationData: Object,
        isCreditCardCampaign: Boolean,
        isDebtSolutionOffer: Boolean,
        offers: Object,
        hasNonAlternativeOffers: Object,
    },
    data() {
        return {
            declinedAndAlt: ['declined', 'alternative', 'flat-declined'],
            yearWithMonth: null,
            iframeOffsetTop: 0,
        }
    },
    mounted() {
        this.iframeAllowedSites = this.themeSetting('iframe_allowed_sites')

        window.addEventListener(
            'message',
            event => {
                const messageContent = event.data

                if (some(this.iframeAllowedSites, ['name', event.origin])) {
                    const variables = split(messageContent, '|')
                    this.iframeOffsetTop = variables[5]
                }
            },
            false,
        )
    },
    computed: {
        showResultHeroLendersBlock: function () {
            return parseInt(this.themeSetting('hide_not_eligible_hero')) !== 1
        },
        status() {
            return this.$store.state.result.status
        },
        firstLenders: function () {
            const show = window.innerWidth >= 992 ? 3 : 2
            return take(this.declinedLenders, show)
        },
        remainingLenders: function () {
            return takeRight(this.declinedLenders, this.declinedLenders.length - this.firstLenders.length)
        },
        previousResultReference() {
            return this.store.getters.getPreviousResult(this.currentResultReference)
        },
        currentResultReference() {
            const currentPath = this.route.fullPath
            const regex = /result\/([a-f0-9]{32})$/
            const matches = regex.exec(currentPath)
            return matches ? matches[1] : null
        },
        isLendindtree: function () {
            return process.env.IS_LENDINDTREE
        },
    },
    methods: {
        isEmpty: isEmpty,
        capitalize: capitalize,
        goTo: function (idName) {
            const element = document.getElementById(idName)
            const top = element.getBoundingClientRect().top + (window.scrollY - 40)

            this.trackEvent('event', {
                eventCategory: 'button',
                eventAction: 'click',
                eventLabel: 'declined-hero-button',
            })

            this.trackEvent('results_element_click', {
                territory: process.env.TERRITORY,
                elementType: 'button',
                elementName: 'declined-hero-button',
            })

            if (window.IS_IFRAME) {
                const parentWindow = window.parent

                parentWindow.postMessage('declinedOffersPosition|' + (top + toNumber(this.iframeOffsetTop)), '*')
            } else {
                window.scrollTo({
                    top: top,
                    left: 0,
                    behavior: 'smooth',
                })
            }
        },
        previousResult: function () {
            this.previousHistory()
            this.emitEvent('previousHistory', this.previousResultReference)
        },
        emitEvent: function (eventName, payload) {
            this.emitter.emit(eventName, payload)
        },
        previousHistory: function () {
            this.trackEvent('event', {
                eventCategory: 'button',
                eventAction: 'click',
                eventLabel: 'previous-search-history',
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.result-hero-wrapper {
    background-position: center;
    background-size: cover;
    color: var(--hero-text);
    font-family: var(--heading-font);
    width: 100%;
    display: flex;

    .container {
        height: 100%;

        @media screen and (max-width: $bp-large) {
            padding-right: 0px;
            padding-left: 0px;
        }

        .col {
            height: 100%;
        }
    }

    .result-hero-container {
        display: flex;
        flex-direction: column;

        @media screen and (min-width: $bp-large) {
            color: var(--hero-text);
            flex-direction: row;
        }
        .result-hero-lenders {
            width: 100%;
            padding-top: 24px;
            padding-bottom: 24px;
            border-top: 1px solid rgba(255, 255, 255, 0.3);
            display: flex;
            flex-direction: row;

            @media screen and (min-width: $bp-large) {
                flex-direction: column;
                width: 25%;
                margin-top: 94px;
                margin-bottom: 42px;
                padding-top: 0px;
                padding-bottom: 0px;
                padding-left: 33px;
                color: var(--hero-text);
                border-top: none;
                border-left: 1px solid rgba(255, 255, 255, 0.3);
            }

            .lender-details {
                height: 100%;
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
                align-items: center;
                margin-left: rem(12.6px);
                margin-right: rem(12.6px);

                @media screen and (min-width: $bp-large) {
                    align-items: flex-start;
                    flex-direction: column;
                }

                .lenders-info {
                    color: var(--hero-text);
                    font-size: rem(16px);
                    font-weight: 600;
                    line-height: rem(19px);
                    letter-spacing: -0.01em;
                    text-align: left;
                    margin-left: 10px;

                    @media screen and (min-width: $bp-large) {
                        color: var(--hero-text);
                        text-align: left;
                        margin-left: 0px;
                    }

                    .colon {
                        display: none;

                        @media screen and (min-width: $bp-large) {
                            display: inline-block;
                        }
                    }
                }

                .lender-pins {
                    align-self: baseline;
                    color: var(--hero-text);
                    display: flex;
                    margin-top: auto;
                    margin-bottom: auto;

                    @media screen and (min-width: $bp-large) {
                        color: var(--hero-text);
                    }

                    .lender-pin {
                        margin-left: -18px;
                        font-size: rem(16px);
                        line-height: rem(19px);
                        padding: 5px;
                        width: 42px;
                        height: 42px;
                        background: #ffffff;
                        color: var(--hero-text);
                        border: 1px solid #e4e4e4;
                        box-sizing: border-box;
                        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.11);
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: center;

                        &:first-child {
                            margin-left: 0px;
                        }

                        @media screen and (min-width: $bp-large) {
                            color: var(--hero-text);
                            width: 48px;
                            height: 48px;
                            font-size: rem(18px);
                            line-height: rem(21px);
                        }

                        img {
                            width: 100%;
                        }

                        &.extra-lender-counter {
                            background: var(--hero-offer-highlight-background);
                        }
                    }
                }
            }

            .lender-actions {
                display: flex;
                color: var(--hero-text);

                @media screen and (min-width: $bp-large) {
                    align-items: flex-end;
                    color: var(--hero-text);
                }

                button {
                    height: unset;

                    &.bordered {
                        padding: 0px;

                        @media screen and (max-width: $bp-large) {
                            padding-left: 5px;
                            border: none;

                            .text {
                                display: none;
                            }
                        }
                    }

                    svg {
                        margin-left: 10px;

                        @media screen and (max-width: $bp-large) {
                            margin-left: 0px;
                        }
                    }
                }
            }
        }
    }
}
</style>
